<div class="version-card">
  <artemis-loading-spinner *ngIf="loading$ | async"></artemis-loading-spinner>
  <div class="version-card__error" *ngIf="error$ | async">
    <img class="version-card__error-icon" src="/assets/icons/exclamation-icon-red.png">
    <span class="version-card__error-text">{{ 'subscriptions.message.error' | translate }}</span>
    <button mat-button ubi-round-button class="btn btn_rounded btn_small version-card__error-retry-btn" (click)="retryGetBillable()">RETRY</button>
  </div>
  <ng-container *ngIf="!(error$ | async)">
    <div class="infotable" *ngIf="userSubscriptions && userSubscriptions.length > 0">
      <div class="infotable__header infotable__header_mb_15">
        {{ 'subscriptions.header' | translate }}
      </div>
      <artemis-popover>
        <ng-container *ngFor="let section of ('subscriptions.info.content' | translate)">
          <ng-container *ngFor="let content of section.paragraph">
            <div class="infotable__popover-text">{{ content }}</div>
          </ng-container>
        </ng-container>
      </artemis-popover>
      <div class="infotable__table">
        <div class="infotable__table-row" *ngFor="let subscription of userSubscriptions">
          <div class="infotable__table-cell infotable__table-cell-subscription-name uppercase-text" [title]="subscription.product">
            {{subscription.product}}
          </div>
          <div class="infotable__table-cell infotable__table-cell-period"
               title="{{subscription.startDate | date: 'dd/MM/yyyy'}} - {{subscription.endDate | date: 'dd/MM/yyyy'}}">
            {{subscription.startDate | date: 'dd/MM/yyyy'}} - {{subscription.endDate | date: 'dd/MM/yyyy'}}
          </div>
        </div>
      </div>
    </div>
    <div class="info-rows">
      <div class="info-row">
        <div class="info-row__name">
          {{ 'subscriptions.title.search_provider' | translate }}
        </div>
        <div class="info-row__data uppercase-text" [title]="appSettings.usedSearchProvidersNames">
          {{appSettings.usedSearchProvidersNames}}
        </div>
      </div>
      <div class="info-row info-row_no-border">
        <div class="info-row__name">
          {{ 'subscriptions.title.face_compare_api' | translate }}
        </div>
        <div class="info-row__data uppercase-text" [title]="appSettings.isFaceCompareOn ? 'Enabled' : 'Disabled'">
          {{appSettings.isFaceCompareOn ? 'Enabled' : 'Disabled'}}
        </div>
      </div>
      <div class="info-row">
        <div class="info-row__name">
          {{ 'subscriptions.title.ocr_check_api' | translate }}
        </div>
        <div class="info-row__data uppercase-text" [title]="appSettings.isOCROn ? 'Enabled' : 'Disabled'">
          {{appSettings.isOCROn ? 'Enabled' : 'Disabled'}}
        </div>
      </div>
      <div class="info-row">
        <div class="info-row__name">
          {{ 'subscriptions.title.nlp_api' | translate }}
        </div>
        <div class="info-row__data uppercase-text" [title]="appSettings.isNLPon ? 'Enabled' : 'Disabled'">
          {{appSettings.isNLPon ? 'Enabled' : 'Disabled'}}
        </div>
      </div>
      <div class="info-row">
        <div class="info-row__name">
          {{ 'subscriptions.title.version' | translate }}
        </div>
        <div class="info-row__data uppercase-text" [title]="appSettings.version">
          {{appSettings.version}}
        </div>
      </div>
    </div>
    <div class="infotable" *ngIf="searchEngines && searchEngines.length > 0">
      <div class="infotable__header infotable__header_mb_15">
        {{ 'credit_summary.header' | translate }}
      </div>
      <div class="infotable__table">
        <ng-container *ngFor="let searchEngine of searchEngines">
          <div class="infotable__table-row" *ngIf="searchEngine.display">
            <div class="infotable__table-cell infotable__table-cell-credits-service-name uppercase-text" [title]="searchEngine.serviceName">
              {{searchEngine.serviceName}}
            </div>
            <div class="infotable__table-cell infotable__table-cell-credits-count"
                 [title]="(searchEngine.remaining || searchEngine.remaining === 0) ?
                          (searchEngine.used  | number: '.0-0') + ' / ' + (searchEngine.remaining + searchEngine.used | number:'.0-0') : 'Unlimited'">
              {{(searchEngine.remaining || searchEngine.remaining === 0) ?
                (searchEngine.used  | number: '.0-0') + ' / ' + (searchEngine.remaining + searchEngine.used | number:'.0-0') : 'Unlimited'}}
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>
